import { featureProviderFlags } from '@fireflyhealth/api'
import keyBy from 'lodash/fp/keyBy'
import { useSelector } from 'react-redux'
import { useQuery } from '~/shared/hooks/query'
export const useFeatureFlags = () => {
  const me = useSelector(state => state.me)

  const query = useQuery(
    featureProviderFlags.listQueryKey(),
    () => featureProviderFlags.list().then(r => r.data),
    {
      staleTime: Infinity,
      enabled: me?.id != null,
    },
  )

  return {
    ...query,
    data: query.data != null ? { featureFlagsByName: keyBy('name', query.data) } : undefined,
  }
}

export const useFeatureFlag = (name: string) => {
  const { data } = useFeatureFlags()
  return !!data?.featureFlagsByName?.[name]?.is_active
}
